// src/admin/shell/SessionTimer.tsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@admin/lib/supabase';
import { useAuth } from '@admin/auth/useAuth';

const INACTIVITY_MS = 8 * 60 * 60 * 1000; // 8 hours
const POLL_MS = 60 * 1000;

export default function SessionTimer() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let lastActivity = Date.now();
    const bump = () => { lastActivity = Date.now(); };
    window.addEventListener('mousemove', bump, { passive: true });
    window.addEventListener('keydown', bump);
    window.addEventListener('click', bump);

    const handle = setInterval(() => {
      void (async () => {
        // Soft timeout: inactivity
        if (Date.now() - lastActivity > INACTIVITY_MS) {
          await signOut();
          navigate(`/login?next=${encodeURIComponent(location.pathname)}`, { replace: true });
          return;
        }
        // Hard check: Supabase session still valid?
        const { data, error } = await supabase.auth.getSession();
        if (error || !data.session) {
          await signOut();
          navigate(`/login?next=${encodeURIComponent(location.pathname)}`, { replace: true });
        }
      })();
    }, POLL_MS);

    return () => {
      clearInterval(handle);
      window.removeEventListener('mousemove', bump);
      window.removeEventListener('keydown', bump);
      window.removeEventListener('click', bump);
    };
  }, [navigate, signOut, location.pathname]);

  return null;
}
